const toSectionValues = (value) => {
  if (Array.isArray(value)) {
    return value.flatMap(toSectionValues);
  }

  if (typeof value === 'string') {
    return [value];
  }

  return [];
};

export const normalizeNewsSections = (news) => {
  if (!news || typeof news !== 'object') {
    return [];
  }

  const categorySections = Array.isArray(news.categories)
    ? news.categories.flatMap((entry) => toSectionValues(entry?.sections))
    : [];

  const values = [
    ...toSectionValues(news.sections),
    ...toSectionValues(news.selectedSections),
    ...toSectionValues(news.section),
    ...categorySections,
  ];

  const uniqueSections = new Map();

  values.forEach((value) => {
    const normalized = value.trim().replace(/\s+/g, ' ');

    if (normalized && !uniqueSections.has(normalized)) {
      uniqueSections.set(normalized, normalized);
    }
  });

  return [...uniqueSections.values()];
};
